export const categories = [
  "all",
  "newArrivals",
  "dresses",
  "skirts",
  "trousers",
  "blouses",
  "shirts",
  "tshirts",
  "sweaters",
  "cardigans",
  "jackets",
  "shorts",
];

export const sizes = [
  "xxs",
  "xs",
  "s",
  "m",
  "l",
  "xl",
  "xxl",
  "xxxl",
  "onesize",
];

export const clients = ["female", "male", "girl", "boy", "infant", "unisex"];

export const fabrics = [
  "cotton",
  "flannel",
  "linen",
  "fleece",
  "canvas",
  "muslin",
  "precuts",
  "stretch",
  "rayon",
  "silk",
  "wool",
  "other",
];
